/* eslint-disable tss-unused-classes/unused-classes */
import React from 'react'
import { AccordionProps } from '@mui/material'
import MuiAccordion from '@mui/material/Accordion'
import { makeStyles } from 'tss-react/mui'
import { styled } from '@mui/material/styles'

export const useAccordionStyles = makeStyles()(theme => ({
  container: {
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.shades.shade03}`,
  },
  accordionSummary: {
    backgroundColor: theme.palette.shades.shade04,
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
  },
  accordionRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  divider: {
    borderColor: theme.palette.divider,
  },
}))

const StyledAccordion = styled((props: AccordionProps) => <MuiAccordion elevation={0} {...props} />)(({ theme }) => ({
  backgroundColor: theme.palette.shades.shade04,
  marginBottom: 0,
  padding: 0,
  '&.MuiAccordion-root': {
    border: 0,
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
  },
  '&.Mui-disabled': {
    borderRadius: 0,
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
  },
}))

export default StyledAccordion
